"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeGetNetworkError = void 0;
const errors_1 = require("@deliverr/errors");
const maybeGetNetworkError = (err) => {
    var _a, _b, _c, _d, _e, _f;
    const httpErrorCode = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
    if (httpErrorCode) {
        const baseURL = (_b = err === null || err === void 0 ? void 0 : err.config) === null || _b === void 0 ? void 0 : _b.baseURL;
        const url = (_c = err === null || err === void 0 ? void 0 : err.config) === null || _c === void 0 ? void 0 : _c.url;
        const method = (_d = err === null || err === void 0 ? void 0 : err.config) === null || _d === void 0 ? void 0 : _d.method;
        const message = err === null || err === void 0 ? void 0 : err.message;
        const data = typeof ((_e = err === null || err === void 0 ? void 0 : err.response) === null || _e === void 0 ? void 0 : _e.data) === "string" && ((_f = err === null || err === void 0 ? void 0 : err.response) === null || _f === void 0 ? void 0 : _f.data.slice(0, 50));
        return new errors_1.DeliverrError({
            code: errors_1.HttpErrorCodes[httpErrorCode] || errors_1.ApiError.UNKNOWN_ERROR,
            message: `"${data || message}" on "${method}" to "${baseURL}"`,
            payload: {
                baseURL,
                url,
                method,
                httpErrorCode,
                message,
                data,
                err,
            },
        });
    }
    return undefined;
};
exports.maybeGetNetworkError = maybeGetNetworkError;
//# sourceMappingURL=maybeGetNetworkError.js.map